import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { useCoco } from 'context/CocoContext';

export default function CocoMessageInput() {
  const [message, setMessage] = useState('');
  const { sendMessage, isStreaming } = useCoco();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = message.trim();
    if (!trimmed || isStreaming) return;
    setMessage('');
    sendMessage(trimmed);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
          <TextField
            fullWidth
            multiline
            maxRows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="How can I help you?"
            variant="outlined"
            size="small"
            disabled={isStreaming}
          />
          <Button
            variant="contained"
            type="submit"
            disabled={isStreaming || !message.trim()}
            sx={{ textTransform: 'none', minWidth: 80 }}
          >
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
}
